import React from 'react'
import {FixedPriceRule} from '../QuotationRule'

export const FixedPriceRuleComponent = ({rule}: {rule: FixedPriceRule}) => {
    return <div className="quotation-detail-rule-structure">
        <p className="quotation-detail-description">Fixed Price</p>
        <p className="quotation-detail-unit-price">{rule?.price}</p>
        <p className="quotation-detail-total">{rule.calculate(0)}</p>
    </div>
}